import React from 'react';
import { useNavigate } from 'react-router-dom';

const SideCard = ({ title, detail, button }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
  };

  return (
    <div>
      <div className="bg-white border border-gray-100 px-4 py-4 max-w-sm rounded-xl overflow-hidden">
        <video className="h-60 w-96 rounded-lg" autoPlay loop muted playsInline>
          <source src="dashboard.mp4" alt="Dashboard visual" type="video/mp4"></source>  
        </video> 
        
      </div>
    </div>
  );
};

export default SideCard;
